import React, { useContext, useState } from 'react';
import { CompanyContext } from '../../../context/CompanyContext';
import DashboardProvider from '../../../providers/DashboardProvider';
import Provider from '../../../providers/common/Provider';
import Content from '../../components/Content';
import { MetricFilter, MetricInterval } from '../../../types/metrics/metricFilter';
import dayjs from 'dayjs';
import { CompanyConnectionContext } from '../../../context/CompanyConnectionContext';
import SectionTitle from '../../../VentoryUI/components/common/SectionTitle';
import CompanySearchSelect from '../../../VentoryUI/components/common/Dashboard/Common/CompanySearchSelect';
import { t } from '../../../types/translation/Translator';
import { TranslationKey } from '../../../types/translation/TranslationKey';
import { OverviewMetrics } from '../../components/Dashboard';

interface DashboardScreenInputProps {}

export default function DashboardScreen({}: DashboardScreenInputProps) {
  const { currentCompany } = useContext(CompanyContext);
  const { companyConnections } = useContext(CompanyConnectionContext);

  const hasTask = !!currentCompany.settings.featureToggles.tasks.tasks;
  const hasOrders = !!currentCompany.settings.featureToggles.orders.orders;
  const hasAssets = !!currentCompany.settings.featureToggles.assets.assets;

  const hasCompanyConnections = Array.from(companyConnections.values()).some(cc => cc.parentId === currentCompany.id);

  const [filter, setFilter] = useState<MetricFilter>(
    new MetricFilter({
      interval: MetricInterval.year,
      start: dayjs('01/01/2020').startOf('day'),
      end: dayjs().endOf('day'),
      companyIds: !hasCompanyConnections ? [currentCompany.id] : [],
    }),
  );

  return (
    <DashboardScreenProvider>
      <Content>
        <div className='flex flex-col gap-2 px-2'>
          <div className='flex items-center justify-between'>
            <SectionTitle text={t(TranslationKey.overview).singular.label} />
            {hasCompanyConnections ? <CompanySearchSelect filter={filter} setFilter={setFilter} /> : null}
          </div>
          <div className='flex flex-col gap-4'>
            <OverviewMetrics filter={filter} setFilter={setFilter} />
            {/* {hasOrders && <OrderMetrics filter={filter} setFilter={setFilter} />} */}
            {/* {hasTask && <TaskMetrics filter={filter} setFilter={setFilter} />} */}
            {/* {hasAssets && <AssetMetrics filter={filter} setFilter={setFilter} />} */}
          </div>
        </div>
      </Content>
    </DashboardScreenProvider>
  );
}

function DashboardScreenProvider({ children }: { children: React.ReactNode }) {
  return (
    <Provider binStatus container order productMasterData stockLocation tagRelation task user>
      <DashboardProvider>{children}</DashboardProvider>
    </Provider>
  );
}
